module.exports = __webpack_public_path__ + "img/HN60.png";